module.exports = __webpack_public_path__ + "static/media/SerifGoodOptimized.0dbf5ae4.png";